import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useDisableUsers = (terminology: 'block' | 'disable' = 'block') => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const disableUsers = async (userIds: string[]) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: { userIds },
    });

    const response = await fetch(`${APIBaseChronos}/api/user/disable`, fetchConfig);

    if (!response.ok) {
      throw new Error(`Failed to disable users: ${response.status}`);
    }
  };

  return useMutation({
    mutationFn: disableUsers,
    onSuccess: () => {
      toast.success(terminology === 'disable' ? 'Users disabled successfully' : 'Users blocked successfully');
      queryClient.invalidateQueries([QueryEntity.Users]);
      queryClient.invalidateQueries([QueryEntity.User]);
    },
    onError: () => {
      toast.error(terminology === 'disable' ? 'Failed to disable users' : 'Failed to block users');
    },
  });
};
